import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../core/design-system/components/Button';
import './styles.css';

const Step2 = ({ onNext, onPrev, selectedActivity, onActivitySelect }) => {
  const { t } = useTranslation('wizard');
  const [selectedType, setSelectedType] = useState('');

  const activityTypes = ['sport', 'social', 'cooking', 'meeting', 'transport'];

  const handleTypeSelect = (type) => {
    setSelectedType(type);
    onActivitySelect(''); // Reset la suggestion sélectionnée
  };

  return (
    <div className="wizard-step-container">
      <div className="wizard-content">
        <h1 className="wizard-title">{t('step2.title')}</h1>
        
        <div className="select-container">
          <label className="select-label">{t('step2.selectActivityLabel')}</label>
          <select
            value={selectedType}
            onChange={(e) => handleTypeSelect(e.target.value)}
            className="select-input"
          >
            <option value="">{t('step2.selectActivityPlaceholder')}</option>
            {activityTypes.map(type => (
              <option key={type} value={type}>
                {t(`step2.activities.${type}`)}
              </option>
            ))}
          </select>
        </div>

        {selectedType && (
          <div className="select-container">
            <label className="select-label">{t('step2.selectSuggestionLabel')}</label>
            <select
              value={selectedActivity}
              onChange={(e) => onActivitySelect(e.target.value)}
              className="select-input"
            >
              <option value="">{t('step2.selectSuggestion')}</option>
              {t(`step2.suggestions.${selectedType}`, { returnObjects: true }).map((suggestion) => (
                <option key={suggestion} value={suggestion}>
                  {suggestion}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      <div className="wizard-actions">
        <Button 
          onClick={onPrev} 
          variant="secondary"
          className="btn-back"
        >
          {t('common.back')}
        </Button>
        <Button 
          onClick={onNext} 
          variant="primary"
          disabled={!selectedActivity}
        >
          {t('common.next')}
        </Button>
      </div>
    </div>
  );
};

export default Step2; 